import { Accordion as ChakraAccordion } from '@chakra-ui/react';
import React from 'react';

type AccordionProps = React.ComponentProps<typeof ChakraAccordion>;

const Accordion = React.forwardRef<HTMLDivElement, AccordionProps>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraAccordion ref={ref} {...props}>
        {children}
      </ChakraAccordion>
    );
  },
);

Accordion.displayName = 'Accordion';

export default Accordion;
